import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import {
  DynamicContentItem,
  DynamicContentSectionInput,
  DynamicContentSectionsResult,
  DynamicContentSectionsResponse
} from './dynamic-content-item.types'

@Injectable()
export class DynamicContentItemService {
  constructor(private http: HttpClient) {}

  public getSections(tagId: number): Observable<DynamicContentSectionsResult> {
    return this.http
      .get<DynamicContentSectionsResponse>(
        `${environment.backendApiUrl}/tags/${tagId}/dynamic-content-sections`
      )
      .pipe(map((response) => this.toResult(response)))
  }

  public replaceSections(
    tagId: number,
    sections: DynamicContentSectionInput[],
    expectedRevision: string
  ): Observable<DynamicContentSectionsResult> {
    return this.http
      .put<DynamicContentSectionsResponse>(
        `${environment.backendApiUrl}/tags/${tagId}/dynamic-content-sections`,
        { sections, expectedRevision }
      )
      .pipe(map((response) => this.toResult(response)))
  }

  private toResult(
    response: DynamicContentSectionsResponse
  ): DynamicContentSectionsResult {
    return {
      entities: response.sections.flatMap((section) =>
        section.translations.map((translation) => ({
          ...translation,
          tagId: response.tagId,
          type: section.type,
          ordinal: section.ordinal,
          sectionHasConflict: section.hasConflict
        }))
      ),
      revision: response.revision
    }
  }
}
